// easyui-tabs.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, Input, Output, ElementRef, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-tabs',
  template:  `
    <div style="height: 100%">
      <div #host>
        <ng-content></ng-content>
      </div>
    </div>
  `
})
export class EasyuiTabsComponent implements AfterViewInit {
  private host: any;
  @Input('options') options: any = {};
  @Output() click = new EventEmitter<string>();
  @Output() keyDown = new EventEmitter<string>();
  @ViewChild('host') hostElement: ElementRef;

  constructor(private element: ElementRef) { }

  ngAfterViewInit() {
    this.configura(this.options);
  }

  // metodi pubblici

  public getOptions(): any {
    return this.host.tabs('options');
  }

  public getPanelOptions(index: number): any {
    return this.host.tabs[index]('panel').panel('options');
  }

  public addTab(options: any) {
    return this.host.tabs('add', options);
  }

  public getTabIndex(tab: any) {
    return this.host.tabs('getTabIndex', tab);
  }

  public getTabGuid(id: string): number {
    const tabs = this.getTabs();
    for (let i = 0; i < tabs.length; i++) {
      const options = tabs[i].panel('options');
      // NB: codguid non è nativo di easyui
      if (options.codguid === id) {
        return i;
      }
    }
    return -1;
  }

  public getTabByTitle(title: string) {
    return this.host.tabs('getTab', title);
  }

  public getTabByIndex(index: number) {
    return this.host.tabs('getTab', index);
  }

  public getTabs() {
    return this.host.tabs('tabs');
  }

  public getSelected() {
    return this.host.tabs('getSelected');
  }

  public getSelectedIndex() {
    const tab = this.host.tabs('getSelected');
    return this.host.tabs('getTabIndex', tab);
  }

  public getSelectedOptions() {
    const tab = this.host.tabs('getSelected');
    return tab.panel('options');
  }

  public selectTab(title: string) {
    return this.host.tabs('select', title);
  }

  public selectTabIndex(index: number) {
    return this.host.tabs('select', index);
  }

  public updateTitleAtIndex(index: number, newTitle: string) {
    const tab = this.host.tabs('getTab', index);
    this.host.tabs('update', {
      tab,
      type: 'header',
      options: {
        title: newTitle
      }
    });
  }

  public updateIconAtIndex(index: number, newIconCls: string) {
    const tab = this.host.tabs('getTab', index);
    this.host.tabs('update', {
      tab,
      type: 'header',
      options: {
        iconCls: newIconCls
      }
    });
  }

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  public closeTab(index: number) {
    this.host.tabs('close', index);
  }

  public panelBody() {
    return this.host.tabs('body');
  }

  public panelHeader() {
    return this.host.tabs('header');
  }

  public panelFooter() {
    return this.host.tabs('footer');
  }

  public panelOuter() {
    return this.host.tabs('panel');
  }

  // metodi privati

  private configura(options: any) {
    this.host = $(this.hostElement.nativeElement);
    if (!options.fit) { options.fit = true; }
    this.host.tabs(options);
    const icon = this.host.find('a');
    if (icon) { icon.removeAttr('href'); }
    const tabs = this.host.tabs('tabs');
    if (tabs && tabs.length) {
      for (let i = 0; i < tabs.length; i++) {
        const inner = tabs[i].panel('options').tab.find('.tabs-inner');
        inner.attr('tabindex', '0');
        inner.on('click', (event) => {
          this.click.emit(event.target.textContent);
        });
        inner.on('keydown', (event) => {
          this.keyDown.emit(event.target.textContent);
        });
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-tabs.component.ts